import { render } from "./MichiganPopuation.vue?vue&type=template&id=4daf1c35&ts=true"
import script from "./MichiganPopuation.vue?vue&type=script&lang=ts"
export * from "./MichiganPopuation.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__